
export class TypePrestation {
	public id: number;
	public name: string;
  public limit_user: number;

  	constructor(
  	) {}
}
